var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: { id: "confirm-submission-modal", "modal-dialog-size": "xl" },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("application.actions.completeApplicationAs")) +
                "\n    "
            ),
            _c("span", { staticClass: "capitalize text-primary ml-1" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("application.filogixStatus." + _vm.completeStatus)
                )
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("lender-submission-changes-table", {
              attrs: {
                "complete-status": _vm.completeStatus,
                "lender-submissions": _vm.lenderSubmissions,
                "application-completed": _vm.applicationCompleted,
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: { loading: _vm.submitting },
                on: { click: _vm.handleCompleteApplicationClick },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("application.actions.completeAs")) +
                    "\n      "
                ),
                _c("span", { staticClass: "capitalize" }, [
                  _vm._v(_vm._s(_vm.completeStatus)),
                ]),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }